export const MAINTENANCE_CHANGED_EVENT = "maihrms:maintenance-changed";

export function dispatchMaintenanceChanged() {
  window.dispatchEvent(new CustomEvent(MAINTENANCE_CHANGED_EVENT));
}
